import PocketBase from 'pocketbase';

const requestTimeout = 5000;
const pocketBaseClient = new PocketBase('/');
const getClient = () => pocketBaseClient;

export const getFileURL = (record, file) => {
  if (!file) return '';
  if (Array.isArray(file)) return file.map((item) => getFileURL(record, item));
  if (typeof file === 'object') return file;
  if (/^(?:https?:|data:|blob:)/i.test(file) || file.startsWith('/')) return file;
  return getClient().files.getURL(record, file);
};

const normalizeDescription = (description) => {
  if (Array.isArray(description)) return description;
  if (typeof description === 'string') return description.split(/\r?\n/);
  return [];
};

export const normalizeWorksRecord = (record) => ({
  ...record,
  id: record.key || record.id,
  isShowInHomePC: record.isShowInHomePC ?? true,
  isShowInHomeSP: record.isShowInHomeSP ?? true,
  isShowInListPagePC: record.isShowInListPagePC ?? true,
  isShowInListPageSP: record.isShowInListPageSP ?? true,
  description: normalizeDescription(record.description),
  descriptionCard: normalizeDescription(record.descriptionCard ?? record.description),
  screenShot1: getFileURL(record, record.screenShot1),
  screenShot2: getFileURL(record, record.screenShot2),
  screenShot3: getFileURL(record, record.screenShot3),
  screenShot4: getFileURL(record, record.screenShot4),
});

const normalizeRecords = (records, normalizeRecord) => {
  const pageRecord = records.find((record) => Array.isArray(record.works));

  if (pageRecord) {
    return {
      ...pageRecord,
      works: pageRecord.works.map((work) => normalizeRecord(work)),
    };
  }

  return {
    works: records.map((record) => normalizeRecord(record)),
  };
};

const fetchCollection = async (collection, lang, normalizeRecord) => {
  const pocketBase = getClient();
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), requestTimeout);

  try {
    const records = await pocketBase.collection(collection).getFullList({
      filter: pocketBase.filter('lang = {:lang}', { lang }),
      sort: 'sort,+created',
      $autoCancel: false,
      signal: controller.signal,
    });

    return normalizeRecords(records, normalizeRecord);
  } finally {
    clearTimeout(timeoutId);
  }
};

const createPocketBaseWorksLoader = ({
  collection,
  lang,
  normalizeRecord = normalizeWorksRecord,
}) => {
  let request;

  return () => {
    if (!request) {
      request = fetchCollection(collection, lang, normalizeRecord)
        .catch((error) => {
          console.warn(
            `[pocketbase] Failed to load ${collection} (${lang}).`,
            error,
          );
          return null;
        });
    }

    return request;
  };
};

export default createPocketBaseWorksLoader;
